import { render, staticRenderFns } from "./SideButtons.vue?vue&type=template&id=147a5c28&"
import script from "./SideButtons.vue?vue&type=script&lang=ts&"
export * from "./SideButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports